import { render, staticRenderFns } from "./ModalConfirmedPlagiarism.vue?vue&type=template&id=6a5fc542&scoped=true"
import script from "./ModalConfirmedPlagiarism.vue?vue&type=script&lang=js"
export * from "./ModalConfirmedPlagiarism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5fc542",
  null
  
)

export default component.exports